import { useFootnoteContext } from "@utils/FootnoteContext";

export const FootnoteList = () => {
  const { footnotes } = useFootnoteContext();
  if (footnotes.length === 0) return null;

  return (
    <section className="container-base py-10">
      <ol className="flex flex-col gap-2">
        {footnotes.map(({ number, value }) => (
          <li key={number} className="flex gap-2 text-body-small text-neutral-light/60">
            <span className="shrink-0">{number}.</span>
            <span>{value}</span>
          </li>
        ))}
      </ol>
    </section>
  );
};
